import { partnerAdminFetch } from '~/api/partnerAdminFetch';
import { PartnerFeatureFlag } from '../../types/resources/PartnerFeatureFlag';

export const getPartnerFeatureFlags = async (
  signOut?: () => void
): Promise<{ partner_feature_flags: PartnerFeatureFlag[] }> => {
  const response = await partnerAdminFetch(
    '/partner_admins/partner_feature_flags',
    {
      method: 'GET',
    },
    signOut
  );

  if (!response.ok) {
    throw new Error(`${response.status} ${response.statusText}`);
  }

  return response.json();
};
